class AutoplayMediaGroup extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.userPaused = false;

    this.querySelector('[data-autoplay-media-toggle]')?.addEventListener('click', this.togglePlayback, {
      signal: this.abortController.signal,
    });
    this.addEventListener('pointerenter', this.pauseForInteraction, {signal: this.abortController.signal});
    this.addEventListener('pointerleave', this.resumeAfterInteraction, {signal: this.abortController.signal});
    this.addEventListener('focusin', this.pauseForInteraction, {signal: this.abortController.signal});
    this.addEventListener('focusout', this.resumeAfterInteraction, {signal: this.abortController.signal});
    this.motionPreference.addEventListener('change', this.handleMotionChange, {signal: this.abortController.signal});

    if (this.motionPreference.matches) {
      this.userPaused = true;
      this.updateButton();
      this.pauseVideos();
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  get videos() {
    return [...this.querySelectorAll('video')];
  }

  pauseVideos = () => this.videos.forEach((video) => video.pause());

  playVideos = () => {
    this.videos.forEach((video) => video.play().catch(() => {}));
  };

  pauseForInteraction = () => this.pauseVideos();

  resumeAfterInteraction = () => {
    requestAnimationFrame(() => {
      if (this.matches(':hover, :focus-within') || this.userPaused || this.motionPreference.matches) return;
      this.playVideos();
    });
  };

  handleMotionChange = () => {
    if (this.motionPreference.matches) {
      this.userPaused = true;
      this.updateButton();
      this.pauseVideos();
    } else if (!this.userPaused && !this.matches(':hover, :focus-within')) {
      this.playVideos();
    }
  };

  updateButton() {
    const button = this.querySelector('[data-autoplay-media-toggle]');
    if (!(button instanceof HTMLButtonElement)) return;

    button.setAttribute('aria-pressed', String(this.userPaused));
    button.setAttribute('aria-label', this.userPaused ? button.dataset.playLabel || '' : button.dataset.pauseLabel || '');
    button.querySelector('[data-pause-icon]')?.toggleAttribute('hidden', this.userPaused);
    button.querySelector('[data-play-icon]')?.toggleAttribute('hidden', !this.userPaused);
  }

  togglePlayback = (event) => {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    this.userPaused = !this.userPaused;
    this.updateButton();

    if (this.userPaused) this.pauseVideos();
    else if (!this.motionPreference.matches) this.playVideos();
  };
}

if (!customElements.get('autoplay-media-group')) {
  customElements.define('autoplay-media-group', AutoplayMediaGroup);
}
